import { Box, Breadcrumbs, SxProps, Tooltip, Typography } from "@mui/material";

type Props = {
  breadcrumbs: string[];
  sx: SxProps;
};

const EntriesWorkDetailsBreadcrumbs = ({ breadcrumbs, sx }: Props) => (
  <Box
    sx={{
      position: "absolute",
      bottom: 0,
      padding: "0.5rem 0.5rem 0 0.5rem",
      ...sx,
    }}
  >
    <Tooltip
      title={breadcrumbs.join(` \u00A0\u00A0>\u00A0\u00A0 `)}
      placement="top"
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            maxWidth: "none", // Remove the max width constraint
          },
        },
      }}
    >
      <Breadcrumbs
        separator="›"
        sx={{
          maxWidth: "306px",
          height: "28px",
          marginLeft: "0.5rem",
          flexWrap: "nowrap",
          overflow: "hidden",
          ol: {
            display: "flex",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
            overflow: "hidden",
          },
          li: {
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
        }}
      >
        {breadcrumbs.map((value, index) => (
          <Typography
            key={`${value}_${index}`}
            variant="header"
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              maxWidth: "150px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </Typography>
        ))}
      </Breadcrumbs>
    </Tooltip>
  </Box>
);

export default EntriesWorkDetailsBreadcrumbs;
